import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListUom({
    loading,
    filteredUoms,
    selected,
    handleSelect,
    handleToggleStatus,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>UOM Code</th>
                        <th>Description</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="4" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredUoms.length > 0 ? (
                        filteredUoms.map((uom) => {
                            const isActive =
                                uom.status === "Active" ||
                                uom.status === 1 ||
                                uom.status === true;

                            return (
                                <tr key={uom.id}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="uomSelect"
                                            disabled={uom.status === "Inactive"}
                                            checked={selected === uom.id}
                                            onChange={() => handleSelect(uom.id)}
                                        />
                                    </td>
                                    <td>{uom.uomCode}</td>
                                    <td>{uom.description}</td>
                                    <td>
                                        <button
                                            type="button"
                                            className={`badge border-0 ${isActive ? "bg-success" : "bg-secondary"
                                                }`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleStatus(uom)}
                                            disabled={loading}
                                        >
                                            {isActive ? "Active" : "Inactive"}
                                        </button>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4" className="text-center text-muted">
                                No UOMs found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
